export default __webpack_public_path__ + "static/media/vessels_ilustration_large.69a767df.jpg";